import { apiClient, ApiClientResponse } from 'common/services/api-client';

interface ApiVersionResponse {
  name: string;
  api: string;
  env: string;
}

export default {
  version: (): Promise<ApiClientResponse<ApiVersionResponse>> => apiClient.get('api/version'),
};
